import { useTranslations } from 'next-intl';
import { IProduct } from '@monofront/types';

interface IProductGoodToKnowProps {
  product: IProduct;
}

const ProductGoodToKnow: React.FC<IProductGoodToKnowProps> = ({ product }) => {
  const tProducts = useTranslations('Products');

  const goodToKnow = product.meta.marketing?.good_to_know || '';

  if (!goodToKnow) return null;

  return (
    <>
      <h3 className="tw-lf-body-xbold-md tw-mt-5">{tProducts('goodToKnow')}</h3>
      <div
        className="tw-lf-rich-text tw-mt-2 tw-leading-normal"
        dangerouslySetInnerHTML={{
          __html: goodToKnow,
        }}
      />
    </>
  );
};

export default ProductGoodToKnow;
